import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/14_beach/14_beach"
 * Contains 1 texture(s)
 */
export class Mobile14BeachAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/14_beach/14_beach';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '14_beach.jpg'
    ] as const;
}
